import { registerQuery } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';
import { EMBED_DASHBOARD_APP_CONFIG, EMBED_DASHBOARD_APP_IDS } from './embed-dashboard-ids';
const EMBEDDED_DASHBOARD_BASE_URL = '/dashboard/v1/embedded-dashboard-settings';
const fetchDashboardIdToEmbeddedAppIdsMapping = () => {
  return http.get(`${EMBEDDED_DASHBOARD_BASE_URL}/dashboard-id-to-embedded-app-ids-mapping`);
};
const filterOutInternalEmbeddedApps = embeddedAppIds => {
  return embeddedAppIds.filter(id => id in EMBED_DASHBOARD_APP_CONFIG && id !== EMBED_DASHBOARD_APP_IDS.KITCHEN_SINK_APP_DASHBOARD_KEY);
};
const fetchUsedInEmbedDashboards = dashboardId => {
  return http.get(`${EMBEDDED_DASHBOARD_BASE_URL}/embedded-app-ids/${dashboardId}`).then(filterOutInternalEmbeddedApps).catch(__err => {
    return [];
  });
};
const getAppName = async embeddedDashboardSetting => {
  const config = EMBED_DASHBOARD_APP_CONFIG[embeddedDashboardSetting.embeddedAppId];
  if (config.hydrateAppName) {
    const name = await config.hydrateAppName(embeddedDashboardSetting.subSpaceId);
    return name;
  }
  return config.getName();
};
const fetchAllEmbeddedDashboardSettingsForPortal = () => {
  return http.get(`${EMBEDDED_DASHBOARD_BASE_URL}`);
};
const fetchEmbeddedDashboardSettingsForDashboard = dashboardId => {
  return http.get(`${EMBEDDED_DASHBOARD_BASE_URL}/dashboard/${dashboardId}`);
};
const fetchDashboardUsedInEmbedApps = async dashboardId => {
  const embeddedDashboardSettings = await fetchEmbeddedDashboardSettingsForDashboard(dashboardId);
  const results = await Promise.allSettled(embeddedDashboardSettings.map(async embeddedDashboardSetting => {
    const config = EMBED_DASHBOARD_APP_CONFIG[embeddedDashboardSetting.embeddedAppId];
    const name = await getAppName(embeddedDashboardSetting);
    return {
      embedDashboardAppId: embeddedDashboardSetting.embeddedAppId,
      link: config.getAppLink(embeddedDashboardSetting.subSpaceId),
      name,
      location: config.location
    };
  }));
  return results.map(result => {
    if (result.status === 'fulfilled') {
      return result.value;
    }
    return undefined;
  }).filter(maybeUsedIn => maybeUsedIn !== undefined);
};
export const GET_USED_IN_EMBED_DASHBOARDS = registerQuery({
  fieldName: 'embeddedAppIds',
  args: ['dashboardId'],
  fetcher({
    dashboardId
  }) {
    return fetchUsedInEmbedDashboards(dashboardId);
  }
});
export const GET_DASHBOARD_USED_IN_EMBED_APPS = registerQuery({
  fieldName: 'dashboardUsedInEmbedApps',
  args: ['dashboardId'],
  fetcher({
    dashboardId
  }) {
    return fetchDashboardUsedInEmbedApps(dashboardId);
  }
});
export const GET_USED_IN_EMBED_DASHBOARDS_FOR_PORTAL = registerQuery({
  fieldName: 'embeddedAppIdsForPortal',
  args: [],
  fetcher() {
    return fetchDashboardIdToEmbeddedAppIdsMapping();
  }
});
export const GET_ALL_EMBEDDED_DASHBOARD_SETTINGS_FOR_PORTAL = registerQuery({
  fieldName: 'allEmbeddedDashboardSettingsForPortal',
  args: [],
  fetcher() {
    return fetchAllEmbeddedDashboardSettingsForPortal();
  }
});